// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2OIHE","footer":"ModalError_footer__37QqL"};